// extracted by mini-css-extract-plugin
var _1 = "MobileAnswerStack_answerCard__b2aa0";
var _2 = "MobileAnswerStack_cardWrapper__2d420";
var _3 = "MobileAnswerStack_counter__02712";
var _4 = "MobileAnswerStack_groupBadge__85611";
var _5 = "MobileAnswerStack_label__40c95";
var _6 = "MobileAnswerStack_mask__bcb86";
var _7 = "MobileAnswerStack_navButtonOuter__280b8";
var _8 = "MobileAnswerStack_navigation__829f6";
var _9 = "MobileAnswerStack_next__5b72c";
var _a = "MobileAnswerStack_outline__98f49";
var _b = "MobileAnswerStack_placeholder__cb151";
var _c = "MobileAnswerStack_prev__55f49";
var _d = "MobileAnswerStack_stackContainer__6a794";
var _e = "MobileAnswerStack_stackWrapper__e0a14";
var _f = "MobileAnswerStack_textInner__d2021";
export { _1 as "answerCard", _2 as "cardWrapper", _3 as "counter", _4 as "groupBadge", _5 as "label", _6 as "mask", _7 as "navButtonOuter", _8 as "navigation", _9 as "next", _a as "outline", _b as "placeholder", _c as "prev", _d as "stackContainer", _e as "stackWrapper", _f as "textInner" }
